import React from 'react';
import ServicesComponent from '../components/Services';
import FAQs from '../components/FAQs';

const Services = () => {
  return (
    <>
      <ServicesComponent />
      <FAQs />
    </>
  );
};

export default Services;

